import I18n from "../i18n";
/**
 * Call channel of appointment, 
 * Call by index of call_channel in appointment.
 */
export const CallChannelKeys = {
	WEB:"web",
	PHONE:"phone",
};
export const CallChannels = {
	undefined:I18n.t("call_channels.unknown"),
	[CallChannelKeys.WEB]:I18n.t("call_channels.video_call"),
	[CallChannelKeys.PHONE]:I18n.t("call_channels.hotLine")
};

export const Sessions = {
	ALL:"all",
	COMPLETED:"completed",
	ONGOING:"ongoing",
	PENDING:"pending",
	INCOMPLETE:"incomplete",
	CANCELLED:"cancelled"
};


// WEBPACK FOOTER //
// ./src/util/appointments.js